// Classes
import CBaseMapeamento, { type TGrupoMapeamento } from '@/services/base/CBaseMapeamento';
import CCliente from '../cliente/CCliente';
import CUsuario from '../usuario/CUsuario';

// Shared
import EPlataforma from '@/shared/enums/EPlataforma';
import ETipoDeDado from '@/shared/enums/ETipoDeDado';
import CSessao from '@/services/storage/CSessao';
import EOrigemTokenJWT from '@/shared/enums/EOrigemTokenJWT';

export default class CMonitoramentoTempoUso {
  cliente: CCliente = new CCliente();
  usuario: CUsuario = new CUsuario();

  sessaoId: string = '';
  path: string = '';
  identificador: string = '';
  plataforma: EPlataforma = EPlataforma.Desconhecido;
  dataHoraInicio: string = '';
  dataHoraTermino: string = '';
  tempoEmMS: number = 0;
  latitude: number = 0;
  longitude: number = 0;

  dia: number = 0;
  mes: number = 0;
  ano: number = 0;

  constructor(pObj?: Partial<CMonitoramentoTempoUso>) {
    if (!pObj) return;
    Object.assign(this, pObj);
  }
}

type TGruposMonitoramentoTempoUso = 'Geral' | 'Cliente' | 'Usuário';

export class CMapeamentoMonitoramentoTempoUso extends CBaseMapeamento<
  CMonitoramentoTempoUso,
  TGruposMonitoramentoTempoUso
> {
  constructor() {
    super();

    // -------------------------------------------------------------
    // DEFINIÇÃO DOS GRUPOS E SEUS ÍCONES
    // -------------------------------------------------------------
    const grupoGeral: TGrupoMapeamento<'Geral'> = { nome: 'Geral', icone: 'mdi-history' };
    const grupoCliente: TGrupoMapeamento<'Cliente'> = { nome: 'Cliente', icone: 'mdi-domain' };
    const grupoUsuario: TGrupoMapeamento<'Usuário'> = { nome: 'Usuário', icone: 'mdi-account-circle-outline' };

    // -------------------------------------------------------------
    // MAPEAMENTO DOS CAMPOS - GRUPO CLIENTE
    // -------------------------------------------------------------

    if (CSessao.sessaoAtual.origem == EOrigemTokenJWT.API) {
      this.add({
        grupo: grupoCliente,
        campoClasse: 'cliente.codigo',
        campoDisplay: 'Cod. Cliente',
        tipo: ETipoDeDado.Integer,
        campoIcone: 'mdi-pound',
      });

      this.add({
        grupo: grupoCliente,
        campoClasse: 'cliente.descricao',
        campoDisplay: 'Desc. Cliente',
        tipo: ETipoDeDado.String,
        campoIcone: 'mdi-card-text-outline',
      });
    }

    // -------------------------------------------------------------
    // MAPEAMENTO DOS CAMPOS - GRUPO USUÁRIO
    // -------------------------------------------------------------

    this.add({
      grupo: grupoUsuario,
      campoClasse: 'usuario.codigo',
      campoDisplay: 'Cod. Usuário',
      tipo: ETipoDeDado.Integer,
      campoIcone: 'mdi-pound',
    });

    this.add({
      grupo: grupoUsuario,
      campoClasse: 'usuario.nome',
      campoDisplay: 'Desc. Usuário',
      tipo: ETipoDeDado.String,
      campoIcone: 'mdi-account-details-outline',
    });

    // -------------------------------------------------------------
    // MAPEAMENTO - GERAL
    // -------------------------------------------------------------

    if (CSessao.sessaoAtual.origem == EOrigemTokenJWT.API) {
      this.add({
        grupo: grupoGeral,
        campoClasse: 'sessaoId',
        campoDisplay: 'Sessão ID',
        tipo: ETipoDeDado.String,
        campoIcone: 'mdi-identifier',
      });

      this.add({
        grupo: grupoGeral,
        campoClasse: 'path',
        campoDisplay: 'Path / Rota',
        tipo: ETipoDeDado.String,
        campoIcone: 'mdi-stackpath',
      });
    }

    this.add({
      grupo: grupoGeral,
      campoClasse: 'identificador',
      campoDisplay: 'Identificador / Menu',
      tipo: ETipoDeDado.String,
      campoIcone: 'mdi-menu',
    });

    this.add({
      grupo: grupoGeral,
      campoClasse: 'plataforma',
      campoDisplay: 'Plataforma',
      tipo: ETipoDeDado.String,
      campoIcone: 'mdi-android',
    });

    this.add({
      grupo: grupoGeral,
      campoClasse: 'dataHoraInicio',
      campoDisplay: 'Data Hora de Início',
      tipo: ETipoDeDado.DateTime,
      campoIcone: '',
      ocultar: true,
    });
  }
}
